export const notificationTypes = {
  SUCCESS: 'success',
  ERROR: 'error',
};

export const sortTypes = {
  ASC: 'asc',
  DESC: 'desc',
};
